<template>
  <div class="laser flex">
    <CenterBeam class="laser self-center h-4 w-full"></CenterBeam>
  </div>
</template>

<script>
import CenterBeam from "./CenterBeam.vue";

export default {
  name: "Laser",
  components: {
    CenterBeam
  }
};
</script>

<style lang="scss">
</style>